export default __webpack_public_path__ + "static/media/2.49cbf9b8.jpg";